import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { dynamicDataAttribute } from 'helpers/utils'

const SummaryItem = ({
  className,
  title,
  price,
  total,
  bold,
  bolder,
  savingField,
  displaymessage,
  phoneNumber,
  atId,
  smaller,
  doubleLine,
  dataAttr,
  ...props
}) =>
  <Block { ...dynamicDataAttribute(dataAttr) } className={ className } { ...props }>
    <Price
      data-at-initial-quote-summary
      { ...dynamicDataAttribute(`${dataAttr}-title`) }
      total={ total }
      bold={ bold }
      bolder={ bolder }
      savingField={ savingField }
      smaller={ smaller }
      left>
      { title }
    </Price>
    {
      <Price
        data-at-quote-instant-savings
        { ...dynamicDataAttribute(`${dataAttr}-price`) }
        right
        total={ total }
        bold={ bold }
        bolder={ bolder }
        savingField={ savingField }
        smaller={ smaller }
        doubleLine={ doubleLine }>
        { savingField ? '-' : '' }${ Math.abs(price || 0).toFixed(2) }
      </Price>
    }
  </Block>

SummaryItem.propTypes = {
  atId: PropTypes.string,
  bold: PropTypes.bool,
  bolder: PropTypes.bool,
  className: PropTypes.string,
  dataAttr: PropTypes.string,
  displaymessage: PropTypes.string,
  doubleLine: PropTypes.bool,
  phoneNumber: PropTypes.string,
  price: PropTypes.number,
  savingField: PropTypes.bool,
  smaller: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  total: PropTypes.bool
}

export default SummaryItem

const Block = styled.div`
  ${Mixin.clearFix()}
`

const Price = styled.span`
  line-height: 30px;
  color: ${Theme.colors.sub_grey};
  ${props => props.savingField && css`
    color: ${Theme.colors.green};
    ${Mixin.font.GothamBold(15)}
  `}
  ${props => props.total && css`
    color: ${Theme.colors.sub_grey};
    ${Mixin.font.GothamBold(18)}
  `}
  ${props => props.bold && css`
    ${Mixin.font.GothamBold()}
  `}
  ${props => props.bolder && css`
    ${Mixin.font.GothamBold()}
  `}
  ${props => props.right && css`
    float: right;
  `}
  ${props => props.left && css`
    float: left;
    max-width: 180px;
    padding-right: 5px;
  `}
  ${props => props.displaymessage && css`
    font-size: 13px;
    line-height: ${props => props.phoneNumber ? '18px' : '33px'};
  `}
  ${props => props.smaller && css`
    font-size: 14px;
    line-height: 18px;
  `}
  ${props => props.doubleLine && css`
    margin-top: 18px;
  `}
`
